// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + "-legacy." + {"214":"3f42051c","348":"61b100b0","511":"63bc91f7","700":"04693457","702":"a10591dc","728":"1b66328e","748":"ab450d6f","789":"fdef0ee4","908":"63c26475","912":"25637df1","955":"3709acd2"}[chunkId] + ".js";
};